import { render, staticRenderFns } from "./edit-pricing-form.vue?vue&type=template&id=d705bff8&"
import script from "./edit-pricing-form.vue?vue&type=script&lang=js&"
export * from "./edit-pricing-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports